// extracted by mini-css-extract-plugin
export default {"button":"Tab_button__zl941","active":"Tab_active__qDb4c"};